import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translateArrayKeys',
    standalone: false
})
export class TranslateArrayKeysPipe implements PipeTransform {
    private translateService = inject(TranslateService);

    transform<T extends Record<string, any>>(arr: T[], keys: Array<keyof T>): T[] {
        return arr.map(obj => {
            keys.forEach(key => {
                const value = obj[key];
                if (typeof value === 'string' && value) {
                    obj[key] = this.translateService.instant(value) as T[typeof key];
                }
            });
            return obj;
        });
    }
}
